import { Injectable } from "@angular/core";
import { BaseLookupService } from "../../impl/BaseLookupService";
import { IInterventionDataLookupService } from "../IInterventionDataLookupService";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class InterventionDataLookupService
  extends BaseLookupService<string, CubiqTS.InterventionEventImpl>
  implements IInterventionDataLookupService
{
  constructor() {
    super(CubiqTS.InterventionEventImpl);
  }

  getItemKey(item: CubiqTS.InterventionEventImpl): string {
    let intervention = item as CubiqTS.InterventionEventImpl;
    return intervention.eventId.toString();
  }

  getInterventionData(id: string): CubiqTS.InterventionEventImpl {
    let intervData = this.getItem(id) as CubiqTS.InterventionEventImpl;
    if (intervData) {
      intervData = Object.assign(new CubiqTS.InterventionEventImpl(), intervData);
    }
    return intervData;
  }

  getInterventionDataset(ids: Array<string>): Array<CubiqTS.InterventionEventImpl> {
    let result = [];
    if (Array.isArray(ids) && ids.length > 0) {
      for (let id of ids) {
        let data = this.getItem(id) as CubiqTS.InterventionEventImpl;
        if (data instanceof CubiqTS.InterventionEventImpl) {
          data = Object.assign(new CubiqTS.InterventionEventImpl(), data);
          result.push(data);
        }
      }
    }
    return result;
  }

  getPricingInterventionDataset(
    requirementIds: Array<string>,
  ): Array<CubiqTS.InterventionEventImpl> {
    let result = [];
    if (Array.isArray(requirementIds) && requirementIds.length > 0) {
      let data: Array<CubiqTS.InterventionEventImpl> = this.getAll().filter((item) => {
        return (
          item instanceof CubiqTS.InterventionEventImpl &&
          item.eventType === CubiqTS.InterventionEventType.FIXING_RATE &&
          item.fixingRateRequirement instanceof CubiqTS.FixingRateRequirementDataImpl &&
          requirementIds.includes(item.fixingRateRequirement.requirementId.toString())
        );
      });

      for (let dataItem of data) {
        let resultItem = Object.assign(new CubiqTS.InterventionEventImpl(), dataItem);
        result.push(resultItem);
      }
    }
    return result;
  }

  getPricingRequirementData(requirementId: string): CubiqTS.FixingRateRequirementData {
    let result: CubiqTS.InterventionEventImpl = this.getAll().find((item) => {
      return (
        item instanceof CubiqTS.InterventionEventImpl &&
        item.eventType === CubiqTS.InterventionEventType.FIXING_RATE &&
        item.fixingRateRequirement instanceof CubiqTS.FixingRateRequirementDataImpl &&
        requirementId === item.fixingRateRequirement.requirementId.toString()
      );
    });
    if (result instanceof CubiqTS.InterventionEventImpl) {
      return result.fixingRateRequirement;
    }
    return null;
  }
}
